import React, { useEffect, useState } from "react";
import api from "../utils/api";

const CategorySidebar = ({ slug, selectedCategory, onSelectCategory }) => {
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAll, setShowAll] = useState(false);
  const LIMIT = 9;
  const [loading, setLoading] = useState(false);

  /* ================= FETCH CATEGORIES ================= */

  const fetchCategories = async (reset = false) => {
    try {
      setLoading(true);

      const res = await api.get(`/api/public/restaurant/${slug}/categories`, {
        params: {
          search: searchQuery,
          // The server pages categories (10 by default); the sidebar shows them all
          limit: 1000,
        },
      });

      setCategories(res.data.categories || []);
    } catch (err) {
      console.error("Failed to fetch categories", err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= INITIAL LOAD ================= */

  useEffect(() => {
    fetchCategories();
  }, [slug]);

  /* ================= SEARCH (DEBOUNCED) ================= */

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchCategories(true);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchQuery]);

  const visibleCategories = showAll ? categories : categories.slice(0, LIMIT);

  return (
    <div className="h-full flex flex-col">
      <h2 className="text-lg text-center font-bold mb-3 text-gray-700">
        Categories
      </h2>

      {/* 🔍 Search */}
      <input
        type="text"
        placeholder="Search categories..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="mb-4 px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
      />

      {/* Category List */}
      <div className="flex-1 overflow-y-auto space-y-2">
        {/* All Categories Button */}
        <button
          onClick={() => onSelectCategory(null)}
          className={`w-full text-left px-4 py-2 rounded-lg transition ${
            !selectedCategory
              ? "bg-teal-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          All Categories
        </button>

        {visibleCategories.map((cat) => (
          <button
            key={cat._id}
            onClick={() => onSelectCategory(cat._id)}
            className={`w-full text-left px-4 py-2 rounded-lg transition ${
              selectedCategory === cat._id
                ? "bg-teal-600 text-white"
                : "bg-gray-100 hover:bg-gray-200"
            }`}
          >
            {cat.newTitle}
          </button>
        ))}

        {/* Load More */}
        {!loading && categories.length > LIMIT && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="w-full text-center py-2 text-teal-600 text-sm font-medium hover:underline"
          >
            {showAll ? "Show Less" : "Show More"}
          </button>
        )}

        {!loading && categories.length === 0 && (
          <p className="text-gray-500 text-sm text-center ">
            No categories found
          </p>
        )}

        {loading && (
          <p className="text-sm text-gray-400 text-center">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default CategorySidebar;
